var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Aggregate", {
    attrs: {
      title: "Storage",
      ItemConstructor: _vm.CaseModel.Storage,
      headers: [
        { text: "Name", value: "name" },
        { text: "Active", value: "active", width: 1 },
      ],
      cardProps: { flat: true, class: [] },
      "toolbar-dense": "",
      dense: "",
    },
    on: {
      change: function ($event) {
        return _vm.$emit("change")
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "item.active",
          fn: function (ref) {
            var item = ref.item
            return [
              _c("v-switch", {
                attrs: { dense: "" },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: item.active,
                  callback: function ($$v) {
                    _vm.$set(item, "active", $$v)
                  },
                  expression: "item.active",
                },
              }),
            ]
          },
        },
        {
          key: "item.capacity",
          fn: function (ref) {
            var storageItem = ref.item
            return [
              _c("td", [_vm._v(_vm._s(storageItem.power_capacity[0]) + " MW")]),
            ]
          },
        },
        {
          key: "default",
          fn: function (ref) {
            var storageItem = ref.item
            var errors = ref.errors
            return [
              _c(
                "v-expand-transition",
                [
                  _c(
                    "v-expansion-panels",
                    {
                      staticClass: "mx-0 px-0",
                      attrs: {
                        tile: "",
                        multiple: "",
                        accordion: "",
                        flat: "",
                      },
                      model: {
                        value: _vm.panels,
                        callback: function ($$v) {
                          _vm.panels = $$v
                        },
                        expression: "panels",
                      },
                    },
                    [
                      _c(
                        "v-expansion-panel",
                        { key: 0 },
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "text-subtitle-1 font-weight-bold" },
                            [_vm._v(" General ")]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("InputGeo", {
                                attrs: {
                                  label: "Coordinates",
                                  "map-height": "150",
                                  nullable: "",
                                  "switch-text": "Set coordinates",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.coordinates,
                                  callback: function ($$v) {
                                    _vm.$set(storageItem, "coordinates", $$v)
                                  },
                                  expression: "storageItem.coordinates",
                                },
                              }),
                              _c(
                                "InputGeneric",
                                { attrs: { label: "Inverter" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: { dense: "", items: _vm.inverters },
                                    model: {
                                      value: storageItem.inverter_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          storageItem,
                                          "inverter_id",
                                          $$v
                                        )
                                      },
                                      expression: "storageItem.inverter_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        { key: 1 },
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "text-subtitle-1 font-weight-bold" },
                            [_vm._v(" Capacity ")]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("InputYearly", {
                                attrs: {
                                  "error-messages": _vm.$utils.getIfExists(
                                    errors,
                                    ["power_capacity"]
                                  ),
                                  label: "Rated Power Capacity",
                                  suffix: "MW",
                                  type: "number",
                                  num_years: _vm.num_years,
                                  year_start: _vm.year_start,
                                  "spread-values": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.power_capacity,
                                  callback: function ($$v) {
                                    _vm.$set(storageItem, "power_capacity", $$v)
                                  },
                                  expression: "storageItem.power_capacity",
                                },
                              }),
                              _c("InputYearly", {
                                attrs: {
                                  label: "Energy Capacity",
                                  suffix: "MWh",
                                  type: "number",
                                  num_years: _vm.num_years,
                                  year_start: _vm.year_start,
                                  "spread-values": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.energy_capacity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "energy_capacity",
                                      $$v
                                    )
                                  },
                                  expression: "storageItem.energy_capacity",
                                },
                              }),
                              _c("InputYearly", {
                                attrs: {
                                  label: _vm.schema.max_charge_power.title,
                                  suffix: _vm.schema.max_charge_power.unit,
                                  type: "number",
                                  num_years: _vm.num_years,
                                  year_start: _vm.year_start,
                                  "spread-values": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.max_charge_power,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "max_charge_power",
                                      $$v
                                    )
                                  },
                                  expression: "storageItem.max_charge_power",
                                },
                              }),
                              _c("InputYearly", {
                                attrs: {
                                  label: _vm.schema.max_discharge_power.title,
                                  suffix: _vm.schema.max_discharge_power.unit,
                                  type: "number",
                                  num_years: _vm.num_years,
                                  year_start: _vm.year_start,
                                  "spread-values": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.max_discharge_power,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "max_discharge_power",
                                      $$v
                                    )
                                  },
                                  expression: "storageItem.max_discharge_power",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("v-divider"),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        { key: 2 },
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "text-subtitle-1 font-weight-bold" },
                            [_vm._v(" Characteristics ")]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("InputTextField", {
                                attrs: { label: "Start Year", type: "number" },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.start_year,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "start_year",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "storageItem.start_year",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  "error-messages": _vm.$utils.getIfExists(
                                    errors,
                                    ["charging_efficiency", "messages"]
                                  ),
                                  label: "Charging Efficiency",
                                  suffix: "%",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.charging_efficiency,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "charging_efficiency",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "storageItem.charging_efficiency",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  "error-messages": _vm.$utils.getIfExists(
                                    errors,
                                    ["discharging_efficiency", "messages"]
                                  ),
                                  label: "Discharging Efficiency",
                                  suffix: "%",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.discharging_efficiency,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "discharging_efficiency",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "storageItem.discharging_efficiency",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label: "Ramping Rate",
                                  hint: "Speed of charge or discharge change",
                                  suffix: "MW/h",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.ramp_rate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "ramp_rate",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "storageItem.ramp_rate",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  suffix: "MWh",
                                  hint: "Initial cumulative energy cycled through BESS",
                                  "error-messages": _vm.$utils.getIfExists(
                                    errors,
                                    ["initial_energy_throughput", "messages"]
                                  ),
                                  label: "Initial Energy Throughput",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.initial_energy_throughput,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "initial_energy_throughput",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "storageItem.initial_energy_throughput",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  hint: "Starting number of BESS charge-discharge cycles",
                                  "error-messages": _vm.$utils.getIfExists(
                                    errors,
                                    ["initial_cycle_count", "messages"]
                                  ),
                                  label: "Initial Cycle Count",
                                  suffix: "cycles",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.initial_cycle_count,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "initial_cycle_count",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "storageItem.initial_cycle_count",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label: "Initial SOC",
                                  hint: "Starting state of charge of BESS/BESS Service",
                                  suffix: "%",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.socMinChange(storageItem)
                                  },
                                },
                                model: {
                                  value: storageItem.initial_soc,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "initial_soc",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "storageItem.initial_soc",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  "error-messages": _vm.$utils.getIfExists(
                                    errors,
                                    ["soc_min", "messages"]
                                  ),
                                  label: "SOC Min",
                                  suffix: "%",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.socMinChange(storageItem)
                                  },
                                },
                                model: {
                                  value: storageItem.soc_min,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "soc_min",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "storageItem.soc_min",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  "error-messages": _vm.$utils.getIfExists(
                                    errors,
                                    ["soc_max", "messages"]
                                  ),
                                  label: "SOC Max",
                                  suffix: "%",
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.soc_max,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "soc_max",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "storageItem.soc_max",
                                },
                              }),
                              _c("InputTextField", {
                                attrs: {
                                  label:
                                    _vm.schema.pa_relaxation_penalty_price
                                      .title,
                                  type: "number",
                                  suffix:
                                    _vm.schema.pa_relaxation_penalty_price.unit,
                                  nullable: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value:
                                    storageItem.pa_relaxation_penalty_price,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "pa_relaxation_penalty_price",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "storageItem.pa_relaxation_penalty_price",
                                },
                              }),
                              _c("InputProfile", {
                                attrs: {
                                  label: "Capacity Fade Curve",
                                  "profile-type": "CAPACITY_FADE",
                                  "object-value": "",
                                  "use-headers": [
                                    "cycle_limit",
                                    "capacity_fade",
                                  ],
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.capacity_fade,
                                  callback: function ($$v) {
                                    _vm.$set(storageItem, "capacity_fade", $$v)
                                  },
                                  expression: "storageItem.capacity_fade",
                                },
                              }),
                              _c(
                                "v-row",
                                { attrs: { align: "baseline" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "4" } },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "d-flex",
                                          attrs: { flat: "" },
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              attrs: { height: "32", flat: "" },
                                            },
                                            [
                                              _c("v-switch", {
                                                staticClass: "mt-0",
                                                attrs: { dense: "" },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.cyclingLimitsChange(
                                                      storageItem
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    storageItem.cycling_limits,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      storageItem,
                                                      "cycling_limits",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "storageItem.cycling_limits",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-card",
                                            { attrs: { flat: "" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class: {
                                                    "subtitle-1": true,
                                                    "text--secondary":
                                                      !storageItem.cycling_limits,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.schema
                                                          .cycling_limits.title
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.schema
                                                          .annual_cycling_limits
                                                          .tooltip
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  storageItem.cycling_limits
                                    ? _c(
                                        "v-col",
                                        { staticClass: "grow" },
                                        [
                                          _c("InputYearly", {
                                            attrs: {
                                              type: "number",
                                              suffix:
                                                _vm.schema.annual_cycling_limits
                                                  .unit,
                                              num_years: _vm.num_years,
                                              year_start: _vm.year_start,
                                              "spread-values": "",
                                              fill: "",
                                              "fill-value":
                                                _vm.schema.annual_cycling_limits
                                                  .items.default,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value:
                                                storageItem.annual_cycling_limits,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  storageItem,
                                                  "annual_cycling_limits",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "storageItem.annual_cycling_limits",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        { key: 3 },
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "text-subtitle-1 font-weight-bold" },
                            [_vm._v(" Costs ")]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("InputYearly", {
                                attrs: {
                                  label: "Charging VOM",
                                  suffix: "$/MWh",
                                  type: "number",
                                  num_years: _vm.num_years,
                                  year_start: _vm.year_start,
                                  fill: "",
                                  "fill-value": 0,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.vom_charge,
                                  callback: function ($$v) {
                                    _vm.$set(storageItem, "vom_charge", $$v)
                                  },
                                  expression: "storageItem.vom_charge",
                                },
                              }),
                              _c("InputYearly", {
                                attrs: {
                                  label: "Discharging VOM",
                                  suffix: "$/MWh",
                                  type: "number",
                                  num_years: _vm.num_years,
                                  year_start: _vm.year_start,
                                  fill: "",
                                  "fill-value": 0,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.vom_discharge,
                                  callback: function ($$v) {
                                    _vm.$set(storageItem, "vom_discharge", $$v)
                                  },
                                  expression: "storageItem.vom_discharge",
                                },
                              }),
                              storageItem.mcc
                                ? _c("InputYearly", {
                                    attrs: {
                                      label: _vm.schema.mcc.title,
                                      suffix: _vm.schema.mcc.unit,
                                      type: "number",
                                      num_years: _vm.num_years,
                                      year_start: _vm.year_start,
                                      fill: "",
                                      "fill-value": 0,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "inputPrepend",
                                          fn: function () {
                                            return [
                                              _c("v-select", {
                                                attrs: {
                                                  label: "MCC Type",
                                                  items:
                                                    _vm.schema.mcc.properties
                                                      .type.enum,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value: storageItem.mcc.type,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      storageItem.mcc,
                                                      "type",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "storageItem.mcc.type",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: storageItem.mcc.profile,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          storageItem.mcc,
                                          "profile",
                                          $$v
                                        )
                                      },
                                      expression: "storageItem.mcc.profile",
                                    },
                                  })
                                : _vm._e(),
                              _c("v-switch", {
                                attrs: {
                                  label: _vm.schema.ppa.title,
                                  hint: _vm.schema.ppa.tooltip,
                                  "persistent-hint": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.ppa.active,
                                  callback: function ($$v) {
                                    _vm.$set(storageItem.ppa, "active", $$v)
                                  },
                                  expression: "storageItem.ppa.active",
                                },
                              }),
                              storageItem.ppa.active
                                ? _c("InputYearlyProfile", {
                                    attrs: {
                                      "object-value": "",
                                      fill: "",
                                      "toggle-items-type": "",
                                      label:
                                        _vm.schema.ppa.properties.charging
                                          .title,
                                      hint: _vm.schema.ppa.properties.charging
                                        .tooltip,
                                      num_years: _vm.num_years,
                                      suffix: "$/MWh",
                                      "profile-type":
                                        _vm.schema.ppa.properties.charging
                                          .profileType,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value: storageItem.ppa.charging,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          storageItem.ppa,
                                          "charging",
                                          $$v
                                        )
                                      },
                                      expression: "storageItem.ppa.charging",
                                    },
                                  })
                                : _vm._e(),
                              storageItem.ppa.active
                                ? _c("InputYearlyProfile", {
                                    attrs: {
                                      "object-value": "",
                                      fill: "",
                                      "toggle-items-type": "",
                                      label:
                                        _vm.schema.ppa.properties.discharging
                                          .title,
                                      hint: _vm.schema.ppa.properties
                                        .discharging.tooltip,
                                      suffix: "$/MWh",
                                      num_years: _vm.num_years,
                                      "profile-type":
                                        _vm.schema.ppa.properties.discharging
                                          .profileType,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value: storageItem.ppa.discharging,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          storageItem.ppa,
                                          "discharging",
                                          $$v
                                        )
                                      },
                                      expression: "storageItem.ppa.discharging",
                                    },
                                  })
                                : _vm._e(),
                              storageItem.ppa.active
                                ? _c("InputYearlyProfile", {
                                    attrs: {
                                      "object-value": "",
                                      fill: "",
                                      "toggle-items-type": "",
                                      label:
                                        _vm.schema.ppa.properties.capacity
                                          .title,
                                      hint: _vm.schema.ppa.properties.capacity
                                        .tooltip,
                                      suffix: "$/MW-month",
                                      num_years: _vm.num_years,
                                      "profile-type":
                                        _vm.schema.ppa.properties.capacity
                                          .profileType,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value: storageItem.ppa.capacity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          storageItem.ppa,
                                          "capacity",
                                          $$v
                                        )
                                      },
                                      expression: "storageItem.ppa.capacity",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("v-divider"),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        { key: 4 },
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "text-subtitle-1 font-weight-bold" },
                            [_vm._v(" Operation ")]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("InputToggleParam", {
                                attrs: {
                                  label:
                                    _vm.schema.operating_status.properties
                                      .active.title,
                                  hint: _vm.schema.operating_status.properties
                                    .active.tooltip,
                                  "error-messages": _vm.$utils.getIfExists(
                                    errors,
                                    ["operating_status"]
                                  ),
                                  "hide-divider": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var param = ref.param
                                        var errors = ref.errors
                                        return [
                                          _c("InputProfile", {
                                            attrs: {
                                              hint: _vm.schema.operating_status
                                                .then.properties.param
                                                .properties.id.tooltip,
                                              "error-messages":
                                                _vm.$utils.getIfExists(errors, [
                                                  "id",
                                                ]),
                                              "profile-type":
                                                "DAILY_OPERATING_STATUS",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: param.id,
                                              callback: function ($$v) {
                                                _vm.$set(param, "id", $$v)
                                              },
                                              expression: "param.id",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: storageItem.operating_status,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      storageItem,
                                      "operating_status",
                                      $$v
                                    )
                                  },
                                  expression: "storageItem.operating_status",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("v-divider"),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        { key: 5 },
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "text-subtitle-1 font-weight-bold" },
                            [
                              _c("span", [
                                _vm._v(" Services "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-regular" },
                                  [
                                    _vm._v(
                                      " (" +
                                        _vm._s(
                                          _vm.activeServicesText(
                                            storageItem.services
                                          )
                                        ) +
                                        ") "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("SystemProjectServices", {
                                attrs: {
                                  year_start: _vm.year_start,
                                  num_years: _vm.num_years,
                                  "project-demands": _vm.demands,
                                  "project-reserves": _vm.reserves,
                                  "project-generators": _vm.generators,
                                  "resource-type": "storage",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: storageItem.services,
                                  callback: function ($$v) {
                                    _vm.$set(storageItem, "services", $$v)
                                  },
                                  expression: "storageItem.services",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("v-divider"),
                        ],
                        1
                      ),
                      storageItem.reactive_services
                        ? _c(
                            "v-expansion-panel",
                            { key: 6 },
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticClass:
                                    "text-subtitle-1 font-weight-bold",
                                },
                                [
                                  _c("span", [
                                    _vm._v(" Reactive Services "),
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-regular" },
                                      [
                                        _vm._v(
                                          " (" +
                                            _vm._s(
                                              _vm.activeServicesText(
                                                storageItem.reactive_services
                                              )
                                            ) +
                                            ") "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      dense: "",
                                      label: "Flicker Control",
                                      hint: "Reduce voltage flicker using reactive power support",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value:
                                        storageItem.reactive_services
                                          .flicker_control.active,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          storageItem.reactive_services
                                            .flicker_control,
                                          "active",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "storageItem.reactive_services.flicker_control.active",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.computedValue,
      callback: function ($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }